//封装axios请求函数

import axios from "axios";

// 封装axios构造函数请求
// 1.先是自定义一个方法名
// 2.然后获取头部token值
// 3.延长器设不设置都可以
const axiosInstance = axios.create({

    // 超时时间 单位是ms，这里设置了3s的超时时间
    timeout: 5000,
    // 公共接口--这里注意后面会讲
    baseURL: process.env.ROOT || 'https://www.chengjitong56.com',
    headers: {
        // X-Litemall-Token这个名称就固定这个
        // 'X-Litemall-Token' : localStorage.getItem("X-Litemall-Token")
    }
})

// 请求拦截器
// 1.请求拦截器，在发请求之前，请求拦截器可以检测到发起请求之前需要做什么事情，把需要做的事情，放在请求拦截器之前
axios.interceptors.request.use(config => {
    // 1.在请求之前，先开始进度条的动画

    //2.发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
    config.data = JSON.stringify(config.data); //数据转化,也可以使用qs转换
    // config.headers = {
    //     'Content-Type':'application/x-www-form-urlencoded' //配置请求头
    // }
    //注意使用token的时候需要引入cookie方法或者用本地localStorage等方法，推荐js-cookie
    // const token = getCookie('accessToken');//这里取token之前，你肯定需要先拿到token,存一下
    // if(token){
    //     config.params = {'token':token} //如果要求携带在参数中
    //     config.headers.token= token; //如果要求携带在请求头中
    // }
    // 2.返回请求数据
    return config

}, error => {
    Promise.reject(error)
})
// 响应拦截器
// 1.相应上面的请求拦截器的需求
// 2.把上面的请求拦截器的需求全部做到
axios.interceptors.response.use(res => {
    //接收到响应数据并成功后的一些共有的处理，关闭loading等
    return res.data
}, error => {
    // /***** 接收到异常响应的处理开始 *****/
    if (error && error.response) {
        // 1.公共错误处理
        // 2.根据响应码具体处理
        switch (error.response.status) {
            case 400:
                error.message = '错误请求'
                break;
            case 401:
                error.message = '未授权，请重新登录'
                break;
            case 403:
                error.message = '拒绝访问'
                break;
            case 404:
                error.message = '请求错误,未找到该资源'
                window.location.href = "/NotFound"
                break;
            case 405:
                error.message = '请求方法未允许'
                break;
            case 408:
                error.message = '请求超时'
                break;
            case 500:
                error.message = '服务器端出错'
                break;
            case 501:
                error.message = '网络未实现'
                break;
            case 502:
                error.message = '网络错误'
                break;
            case 503:
                error.message = '服务不可用'
                break;
            case 504:
                error.message = '网络超时'
                break;
            case 505:
                error.message = 'http版本不支持该请求'
                break;
            default:
                error.message = `连接错误${error.response.status}`
        }
    } else {
        // 超时处理
        if (JSON.stringify(error).includes('timeout')) {
            //此处可以统一进行报错拦截展示处理
            error.message = '服务器响应超时，请刷新当前页'
        }
        error.message = '连接服务器失败'
    }
    // /***** 处理结束 *****/
    //如果不需要错误处理，以上的处理过程都可省略
    return Promise.resolve(error.response)
})

// 对外暴露前面创建的构造方法
export default axiosInstance